export const TABLET_BREAKPOINT = 640;
export const MOCK_WIDGET_ID = 'widget-test-id';

export const DEFAULT_FORM_FIELD_SETTINGS = {
  width: 100,
  id: 'lr7rww88',
  fieldID: 'email',
  label: 'Email',
  type: 'email',
  showLabel: false,
  required: true,
  $$key: []
};
